module.exports = __webpack_public_path__ + "static/media/tickAppointment.595b1db1.svg";